import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import { store } from './store';
import {
  addressLookupApi,
  productCalculationsApi,
  adminAuthApi,
  recaptchaApi,
  lexisNexisApi,
} from 'store/api';
import 'styles/reset.scss';
import './index.scss';
import ApiProvider, { IApiProviderValue } from 'providers/ApiServiceProvider';
import SettingsCountryProvider from 'providers/SettingsCountryProvider';
import LoadersProvider from 'providers/LoadersProvider';
import GoogleAnalyticsProvider from 'providers/GoogleAnalyticsProvider';
import { VariablesBySystemNameLoader } from 'loaders/Variables/VariablesBySystemNameLoader';
import AppTheme from 'AppTheme';
import ErrorBoundary from 'ErrorBoundary';
import LocalizationProvider from 'providers/LocalizationProvider';
import EntryRouter from 'routes/entry-router';
import CustomCssConfigProvider from 'providers/CustomCssConfigProvider';
import RecaptchaProvider from 'providers/RecaptchaProvider';
import TestModeNotificationsProvider from 'providers/TestModeNotificationsProvider';
import { GlobalLoaderWrapper } from 'components/PageLayout/GlobalLoaderWrapper';

const apiProviderValue: IApiProviderValue = {
  addressLookupApi,
  productCalculationsApi,
  adminAuthApi,
  recaptchaApi,
  lexisNexisApi,
};

const loaders = [{
  component: VariablesBySystemNameLoader,
}];

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ErrorBoundary>
    <StrictMode>
      <Provider store={store}>
        <StyledEngineProvider injectFirst enableCssLayer>
          <GlobalStyles styles="@layer theme,base,mui,components,utilities;" />
          <ApiProvider value={apiProviderValue}>
            <GoogleAnalyticsProvider>
              <RecaptchaProvider>
                <SettingsCountryProvider>
                  <LoadersProvider loaders={loaders}>
                    <CustomCssConfigProvider>
                      <AppTheme>
                        <LocalizationProvider>
                          <GlobalLoaderWrapper>
                            <TestModeNotificationsProvider>
                              <EntryRouter />
                            </TestModeNotificationsProvider>
                          </GlobalLoaderWrapper>
                        </LocalizationProvider>
                      </AppTheme>
                    </CustomCssConfigProvider>
                  </LoadersProvider>
                </SettingsCountryProvider>
              </RecaptchaProvider>
            </GoogleAnalyticsProvider>
          </ApiProvider>
        </StyledEngineProvider>
      </Provider>
    </StrictMode>
  </ErrorBoundary>,
);
